import React from "react";
import SkyCartLanding from "./pages/SkyCartLanding";
import SkyCartDevPage from "./pages/SkyCartDevPage";

function SkyCart(){

    return  <div id={'skycart_dev-page'}>
        {/*<SkyCartLanding />*/}
        <SkyCartDevPage />

        <footer className={'text-center'}>
            <small className="fixed bottom-0 inset-x-0 bg-blue-00 p-4 text-gray-700">
                v1.0.1 build: 11015
            </small>
        </footer>
    </div>
}

export default SkyCart;
